import React from 'react';
import {
  ORDER_BY_PRICE_ASC,
  ORDER_BY_RATING_DESC,
  PRICE_SORT_ACSENDING_TEXT,
  RATING_SORT_DESCENDING_TEXT
} from '../../constants/miscellaneousConstants';
import { sortOptionTypes } from '../../pages/RouteTemplate/RouteDataTypeChecker';

export const RouteCabsV2SortBar = ({
  setSortOptionsOpen,
  sortOptionsOpen,
  sortType,
  setSortType,
  data,
  sourceCityName,
  destinationCityName
}: {
  setSortOptionsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  sortOptionsOpen: boolean;
  sortType: sortOptionTypes;
  setSortType: React.Dispatch<React.SetStateAction<sortOptionTypes>>;
  data: any;
  sourceCityName: string;
  destinationCityName: string;
}) => {
  const sortInfoList = [
    { sortingType: ORDER_BY_PRICE_ASC, sortTitle: PRICE_SORT_ACSENDING_TEXT },
    {
      sortingType: ORDER_BY_RATING_DESC,
      sortTitle: RATING_SORT_DESCENDING_TEXT
    }
  ];
  return (
    <div className="blueGradientBG paddingTB24">
      <div className="centerPageContainer">
        <div className="cabSorter">
          <div className="makeRelative">
            <span className="font16 tundoraBlackColor latoRegular makeFlex">
              <span>Sorted By&ensp;</span>
              <span
                className="cursorPointer deepskyBlueText"
                onClick={() => setSortOptionsOpen(!sortOptionsOpen)}
              >
                {sortType == ORDER_BY_PRICE_ASC ? (
                  <>
                    <span className="latoBlack">Price</span>
                    <span className="latoRegular">
                      {' '}
                      {`(${PRICE_SORT_ACSENDING_TEXT})`}
                    </span>
                  </>
                ) : (
                  <>
                    <span className="latoBlack">Ratings</span>
                    <span className="latoRegular">
                      {' '}
                      {`(${RATING_SORT_DESCENDING_TEXT})`}
                    </span>
                  </>
                )}
                <span
                  className={`paddingLR8 maxSize12 arrow ${
                    sortOptionsOpen ? 'arrow-top-wide' : `arrow-down-wide`
                  }`}
                ></span>
              </span>
            </span>
            {sortOptionsOpen ? (
              <>
                <div className="makeAbsolute sortOptionsPopup makeFlex column">
                  {sortInfoList.map(({ sortingType, sortTitle }) => (
                    <div
                      className="padding15 cursorPointer"
                      onClick={() => {
                        setSortType(sortingType as sortOptionTypes);
                        setSortOptionsOpen(false);
                      }}
                    >
                      <p className="font15 darkGreyText latoBlack">
                        Price
                        <span className="latoRegular">{` (${sortTitle})`}</span>
                      </p>
                    </div>
                  ))}
                </div>
                <div
                  className="hsBackDrop"
                  onClick={() => setSortOptionsOpen(false)}
                ></div>
              </>
            ) : null}
          </div>
        </div>
        &ensp; | &ensp;
        <span className="font16 darkGreyText latoRegular">
          {`Showing ${data.cabsList.length} out of ${
            data.cabsList.length
          } cabs from ${sourceCityName} to ${destinationCityName} ${
            data.oneWayDistance && data.oneWayDurationInHrMins
              ? `( Distance for selected
            route is ${data.oneWayDistance}kms |  ${data.oneWayDurationInHrMins} )`
              : ''
          } `}
        </span>
      </div>
    </div>
  );
};
